<template>
  <div>
    <v-text-field
      v-model="searchImage"
      append-icon="mdi-magnify"
      label="Buscar"
      single-line
      hide-details
      class="mx-5 mb-3"
    ></v-text-field>
    <v-data-table
      :headers="headersImage"
      :items="listStudies"
      :search="searchImage"
      :items-per-page="10"
      :footer-props="{
        'items-per-page-text': 'Elementos por página',
        'items-per-page-all-text': 'Todo'
      }"
      no-results-text="Sin resultados coincidentes con la búsqueda"
      loading-text="Cargando..."
      no-data-text="Sin resultados disponibles"
      class="mx-5"
      dense
      fixed-header
      height="auto"
    >
      <template v-slot:[`item.count`]="{ index }">
        {{ index + 1 }}
      </template>
      <template v-slot:[`item.status`]="{ item }">
        <span>{{ item.studyStatus }}</span>
      </template>
      <template v-slot:[`item.interpreter`]="{ item }">
        <span v-if="item.interpreter">{{ item.interpreter }}</span>
        <span v-else> - - - </span>
      </template>
      <template v-slot:[`item.actions`]="{ item }">
  <div class="d-flex align-center" >
    <!-- Botón para la interpretación PDF (siempre visible) -->
    <v-tooltip top v-if="!isPap(item)">
      <template v-slot:activator="{ on, attrs }">
        <v-btn
          icon
          @click="downloadInterpretationImage(item, 1)"
          :disabled="sending || !interpretationDownload(item)"
          v-bind="attrs"
          v-on="on"
        >
          <v-icon color="red" dark>mdi-file-pdf-box</v-icon>
        </v-btn>
      </template>
      <span>Descargar interpretación PDF</span>
    </v-tooltip>

    <v-tooltip top v-if="item.modality && item.modality.toUpperCase() === 'PAPANICOLAOU'">
      <template v-slot:activator="{ on, attrs }">
        <v-btn
          icon
          @click="downloadInterpretationImage(item, 1)"
          :disabled="sending || !interpretationDownload(item)"
          v-bind="attrs"
          v-on="on"
        >
          <v-icon color="red" dark>mdi-file-pdf-box</v-icon>
        </v-btn>
      </template>
      <span>Informe médico</span>
    </v-tooltip>

    <v-tooltip top v-if="item.modality && item.modality.toUpperCase() === 'PAPANICOLAOU'">
      <template v-slot:activator="{ on, attrs }">
        <v-btn
          icon
          @click="downloadInterpretationImage(item, 0)"
          :disabled="sending || !interpretationDownload(item)"
          v-bind="attrs"
          v-on="on"
        >
          <v-icon color="red" dark>mdi-file-pdf-box</v-icon>
        </v-btn>
      </template>
      <span>Entregable a paciente </span>
    </v-tooltip>


    <!-- Segundo botón: solo para la modalidad COLPOSCOPIA -->
    <v-tooltip top v-if="item.modality && item.modality.toUpperCase() === 'COLPOSCOPIA'">
      <template v-slot:activator="{ on, attrs }">
        <v-btn
          icon
          @click="downloadInterpretationImage(item,0)"
          :disabled="sending || item.idInterpretation == null"
          v-bind="attrs"
          v-on="on"
          class="mr-1" 
        >
          <v-icon color="red" dark>mdi-file-pdf-box</v-icon>
        </v-btn>
      </template>
      <span>Entregable a paciente</span>
    </v-tooltip>

    <v-menu offset-y :nudge-width="100" :close-on-content-click="true" v-if="showMoreOptions(item)">
      <template v-slot:activator="{ on: menu, attrs }">
        <v-tooltip bottom>
          <template v-slot:activator="{ on: tooltip }">
            <v-btn icon v-bind="attrs" v-on="{ ...tooltip, ...menu }">
              <v-icon>mdi-dots-vertical</v-icon>
            </v-btn>
          </template>
          <span>Más opciones</span>
        </v-tooltip>
      </template>
      <v-list dense>
        <v-list-item
          link
          @click="downloadZIP(item)"
          :disabled="sending || item.idInterpretation == null"
          v-if="!isPap(item) && $utilFront.withPermission($prm.DOWNLOAD_DICOM_CLINIC_HISTORY)"
        >
          <v-list-item-icon>
            <v-icon color="blue">mdi-folder-download</v-icon>
          </v-list-item-icon>
          <v-list-item-content>
            <v-list-item-title>Archivos DICOM</v-list-item-title>
          </v-list-item-content>
        </v-list-item>

        <v-list-item
          link
          @click="downloadInterpretationImage(item, 2)"
          :disabled="sending  || (item.studyStatus || '').toUpperCase() !== 'VALIDADO'"
         v-if="isPap(item)"
        >
          <v-list-item-icon>
            <v-icon color="red" dark>mdi-file-pdf-box</v-icon>
          </v-list-item-icon>
          <v-list-item-content>
            <v-list-item-title>Descargar resultados</v-list-item-title>
          </v-list-item-content>
        </v-list-item>

         <view-image-item
          v-if="$utilFront.withPermission($prm.VIEWER_WEB_HIST)"
          :send="() => sending = !sending"
          :sending="sending"
          :idStudy="item.idStudy"
        />
      </v-list>
    </v-menu>
  </div>
</template>

    </v-data-table>
  </div>
</template>

<script>

import ViewImageItem from "@/app/components/common/study/ViewImageItem.vue";

export default {
  props: {
    downloadInterpretationImage: Function,
    downloadZIP: Function,
    listStudies: Array,
    sending: Boolean,

  },
  components:{
    ViewImageItem
  },
  data() {
    return {
      searchImage: "",
      headersImage: [
        { text: "#", value: "count" },
        { text: "Id Estudio", value: "idStudy" },
        { text: "Fecha de solicitud", value: "registrationDate" },
        { text: "Modalidad", value: "modality" },
        { text: "Estudio", value: "studyType" },
        { text: "Intérprete", value: "interpreter" },
        { text: "Fecha de interpretación", value: "interpretationDate" },
        { text: "Acciones", value: "actions", sortable: false },
      ],
    }
  },
  methods: {
    interpretationDownload(item) {
      const isPap = (item.modality   || '').toUpperCase() === 'PAPANICOLAOU' ||
                    (item.studyType  || '').toUpperCase() === 'PAPANICOLAOU';

    
      if (isPap) {
        return (item.studyStatus || '').toUpperCase() === 'VALIDADO' ||
               Number(item.status) === 13; 
      }

      return item.idInterpretation !== null;
    },

    // Helpers para Colpo y Papa 

    isPap(item) {
      return (item.modality || '')
        .toUpperCase() === 'PAPANICOLAOU' ||
        (item.studyType || '')
        .toUpperCase() === 'PAPANICOLAOU';
    },
    isColpo(item) {
      return (item.modality || '')
        .toUpperCase() === 'COLPOSCOPIA';
    },

    showMoreOptions(item) {
    const canDicom =
      !this.isPap(item) &&
      this.$utilFront.withPermission(this.$prm.DOWNLOAD_DICOM_CLINIC_HISTORY);

    const canPapResults = this.isPap(item);

    const canWebViewer =
      this.$utilFront.withPermission(this.$prm.VIEWER_WEB_HIST);

    return canDicom || canPapResults || canWebViewer;
  },
  },
};
</script>

<style></style>
